import React from 'react';
import { Colors } from 'library';
import { Chip, Text } from 'library/ui';

export function CredentialPill({ label, selected }: { label: string; selected: boolean }) {
    const bgColor = selected ? Colors.secondary : Colors.fill;
    const textColor = selected ? Colors.white : Colors.primary;

    return (
        <Chip bgColor={bgColor} textColor={textColor} variant="filled">
            <Text size="sm" weight="bold" tone={selected ? 'overlay' : 'primary'}>
                {label}
            </Text>
        </Chip>
    );
}
